import {FC} from 'react';
import {termsOfUseSx} from './TermsFrench.sx';
import {Box, Typography} from '@mui/material';

export const TermsFrench: FC = () => {
    return (
        <Box sx={termsOfUseSx.root}>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT SA · 1-3 Rue des Sablières, 1242 Satigny · Version du 10 septembre 2026
            </Typography>
            <Typography variant="h2">Conditions générales d’utilisation des sites web</Typography>


            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                1. Objet
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Les présentes conditions générales (les « Conditions générales ») de AMP IT SA et/ou ses filiales,
                holding ou société sœur (« AMP IT ») régissent l'utilisation des sites internet amp-it.com et amp-it.ch
                (le « site internet ») ainsi que l'utilisation de toutes les applications (SaaS) et logiciels proposés
                par AMP IT, y compris l'application mobile (les « applications ») (le site internet et les applications,
                ensemble les « services »).
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                À des fins rédactionnelles, l'utilisation du singulier comprend le pluriel et inversement et
                l'utilisation du masculin comprend aussi le féminin et inversement. En utilisant le site internet et les
                applications, chaque utilisateur déclare avoir pris connaissance des présentes Conditions générales et
                en accepter le contenu sans réserve. Chaque utilisateur est également informé de la politique de
                confidentialité d'AMP IT. Aucune condition générale contraire ou dérogeant aux présentes Conditions
                générales ou aux conditions générales spécifiques d'AMP IT n'est applicable dans les relations entre
                cette dernière et l'utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                2. Conditions générales spécifiques d'AMP IT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT se réserve le droit de soumettre à un utilisateur d'éventuelles conditions générales spécifiques,
                distinctes, cumulatives et/ou dérogeant aux présentes Conditions générales dans le cadre de ses
                services. Ces conditions générales spécifiques s'appliqueront sans réserve dans la relation
                contractuelle entre AMP IT et l'utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                3. Recours aux services
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Tout utilisateur peut naviguer sur la partie publique du site internet sans avoir l'obligation de
                procéder à son inscription. L'inscription d'un utilisateur est néanmoins obligatoire pour utiliser les
                applications et recourir aux services d'AMP IT. AMP IT se réserve le droit de fermer toute navigation
                publique et de requérir l'inscription des utilisateurs à tout moment pour accéder à ses services.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Les services proposés par AMP IT ne sont ouverts qu'aux personnes majeures et capables de discernement
                ainsi qu'aux personnes morales inscrites dans un registre du commerce ou dont l'existence peut être
                prouvée par pièces.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Si l'utilisateur est une personne morale, AMP IT peut valablement communiquer avec chaque personne
                inscrite au registre du commerce individuellement (y compris si cette personne dispose d'une signature
                collective ou ne dispose d'aucun pouvoir de signature) ou avec toute personne impliquée dans le
                traitement de l'affaire pour le compte de la personne morale (y compris si elle ne figure pas au
                registre du commerce) ; si tant est que nécessaire, la documentation contractuelle avec AMP IT (ce qui
                inclut ces Conditions générales) vaut procuration de la personne morale en faveur de ces personnes.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                4. Instructions
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT ne reçoit aucune instruction des utilisateurs. Si un utilisateur devait donner une quelconque
                instruction à AMP IT, celle-ci ne serait valablement donnée que si AMP IT acceptait celle-ci. À défaut
                d'une telle acceptation, AMP IT n'assume aucune obligation — y compris en cas d'urgence — vis-à-vis de
                l'utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                5. Véracité des informations et modifications ultérieures
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Tout utilisateur qui utilise les applications pour bénéficier des services d'AMP IT et/ou qui souhaite
                bénéficier des services d'AMP IT s'engage à fournir, lors de la création d'un compte utilisateur, des
                informations véridiques et, sur demande d'AMP IT, d'éventuelles pièces justificatives.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque utilisateur est responsable des informations transmises lors de son inscription et enregistrées
                dans son compte utilisateur et assume seul la responsabilité de son utilisation. Afin de bénéficier des
                services d'AMP IT, chaque utilisateur s'engage à maintenir les informations de son compte à jour. Si AMP
                IT recourt à des prestations de tiers pour vérifier les informations d'un utilisateur, les données
                recueillies par ce tiers après vérification seront utilisées par AMP IT et remplaceront celles
                enregistrées par l'utilisateur (par exemple en cas d'erreurs constatées à la suite d'une vérification
                des données en lien avec la facturation ou autres).
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT part du principe que les renseignements et documents fournis par chaque utilisateur sont complets
                et conformes à la vérité ; ainsi, AMP IT n'a aucune obligation de procéder à des vérifications
                complémentaires et peut se baser sur les renseignements et documents fournis par l'utilisateur. Si des
                renseignements ou documents fournis par l'utilisateur doivent être mis à jour, chaque utilisateur
                s'engage à immédiatement mettre à jour ses informations. Chaque utilisateur doit s'assurer qu'AMP IT
                reçoive à temps toutes les informations nécessaires pour la réalisation de ses services.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT peut à tout moment procéder à une vérification des informations enregistrées par un utilisateur
                et lui demander des justificatifs. En cas de non-respect du devoir d'information, AMP IT peut, à tout
                moment, fermer le compte d'un utilisateur et/ou renoncer à lui offrir des prestations — aux frais de
                l'utilisateur — et sans aucune responsabilité quelconque.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un utilisateur ou d'un tiers de tout
                dommage, y compris indirect ou consécutif comprenant notamment la perte de manque à gagner, d'économie,
                de production, de contrat ou d'opportunités commerciales en lien avec une information incomplète ou
                erronée.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                6. Collaboration avec AMP IT
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque utilisateur s'engage à accomplir, à la première demande d'AMP IT, tout acte et à signer tous
                éventuels documents qui pourraient être nécessaires pour réaliser et/ou exécuter les obligations d'AMP
                IT.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                7. Communication
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                L'utilisateur accepte que toute correspondance puisse être transmise électroniquement et/ou mise à sa
                disposition dans l'application concernée, y compris de manière non cryptée. AMP IT part du principe que
                les communications adressées à chaque utilisateur et/ou à toute personne impliquée dans le traitement de
                l'affaire lui sont parvenues. AMP IT n'est ainsi pas tenue de s'assurer de la bonne réception de chaque
                communication par d'autres moyens.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque utilisateur est informé et consent à ce que toute communication avec AMP IT puisse être utilisée
                et/ou dévoilée par cette dernière dans l'accomplissement de ses engagements. Dans ce contexte, AMP IT
                est autorisée — sans aucune limitation — à dévoiler l'information communiquée par un utilisateur à un
                tiers, dans la mesure du nécessaire. AMP IT est libérée de tout éventuel secret, respectivement devoir
                de diligence, dans le cadre de ses communications avec les utilisateurs et des tiers.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Afin de permettre à chaque utilisateur d'accéder lui-même à sa documentation, AMP IT peut utiliser
                certains outils accessibles directement par l'utilisateur. AMP IT met tout en œuvre pour assurer, en
                tout temps, l'accès au compte de chaque utilisateur et/ou la disponibilité de ses applications et
                services, mais ne peut le garantir.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un utilisateur ou d'un tiers de tout
                dommage, y compris indirect ou consécutif comprenant notamment la perte de manque à gagner, d'économie,
                de production, de contrat ou d'opportunités commerciales, notamment en cas de divulgation d'information,
                de problème d'accès à la documentation et/ou d'accessibilité aux outils, applications et/ou services
                d'AMP IT par l'utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                8. Stockage des données et fonctionnement paperless
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT dématérialise au maximum ses services et la gestion des documents. En principe, tous les
                documents sous format papier sont numérisés, puis détruits. Chaque utilisateur est rendu attentif au
                fait qu'aucun dossier papier n'est constitué au sein d'AMP IT. Si l'utilisateur remet des documents à
                AMP IT sans sa demande préalable, il s'expose au risque que ceux-ci soient détruits. Dans tous les cas,
                AMP IT est libre de détruire toutes pièces et/ou données relatives à un utilisateur à l'expiration d'un
                délai de dix ans.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un utilisateur ou d'un tiers de tout
                dommage, y compris indirect ou consécutif comprenant notamment la perte de manque à gagner, d'économie,
                de production, de contrat ou d'opportunités commerciales en lien avec la destruction de données et/ou de
                documents.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                9. Incessibilité du compte d'utilisateur
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque compte utilisateur est personnel et ne peut en aucun cas être cédé à un tiers sans l'autorisation
                préalable écrite d'AMP IT. Une personne morale peut avoir plusieurs comptes nominatifs (aux noms de
                différents utilisateurs). Chaque utilisateur s'engage à prendre toutes les mesures pour garder secret et
                préserver la confidentialité de son compte. La confidentialité d'un compte relève exclusivement de la
                responsabilité de l'utilisateur et ce dernier libère AMP IT de toute responsabilité à cet égard.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque utilisateur est responsable de l'utilisation de son compte et assume les opérations effectuées
                découlant de cette utilisation (y compris en cas d'utilisation sans autorisation). Chaque utilisateur
                est tenu d'informer immédiatement AMP IT en cas de perte d'accès ou d'utilisation frauduleuse de son
                compte.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un utilisateur ou d'un tiers de tout
                dommage, y compris indirect ou consécutif comprenant notamment la perte de manque à gagner, d'économie,
                de production, de contrat ou d'opportunités commerciales en lien avec une utilisation indue d'un compte
                d'utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                10. Disponibilité des services
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT met tout en œuvre pour assurer le recours à ses services en tout temps, mais ne peut le garantir.
                AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un utilisateur ou d'un tiers de tout
                dommage, y compris indirect ou consécutif comprenant notamment la perte de manque à gagner, d'économie,
                de production, de contrat ou d'opportunités commerciales en lien avec une indisponibilité de ses
                services.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                11. Support
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Tout support d'AMP IT se fait au travers de ses applications, notamment au moyen du formulaire de
                contact intégré. L'utilisateur n'est pas en droit de réclamer un support téléphonique ou dans les locaux
                d'AMP IT. Des frais particuliers peuvent être facturés à un utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                12. Cadre réglementaire
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque utilisateur est conscient que le cadre réglementaire suisse doit en tout temps être respecté.
                Chaque utilisateur est lui-même tenu de s'assurer de la légalité de ses actes dans le cadre de
                l'utilisation des services. AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un
                utilisateur ou d'un tiers de tout dommage, y compris indirect ou consécutif comprenant notamment la
                perte de manque à gagner, d'économie, de production, de contrat ou d'opportunités commerciales en lien
                avec une violation par l'utilisateur du cadre réglementaire.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                13. Défaut de tout conseil et de recommandation — assistant virtuel
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Chaque utilisateur reconnaît et comprend qu'AMP IT ne prodigue aucun conseil et ne donne aucune
                recommandation. Chaque utilisateur est donc seul responsable de ses choix dans le recours aux services
                d'AMP IT.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Aucune information et/ou document fournis sur le site internet et/ou les applications ne doit être
                considérée comme une recommandation, un conseil, une sollicitation ou une incitation à effectuer un acte
                plutôt qu'un autre.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT met à disposition des utilisateurs un assistant virtuel reposant sur une intelligence
                artificielle, destiné à faciliter le support et à répondre aux demandes courantes relatives aux
                services. L'utilisateur est informé, au début de chaque conversation, qu'il s'adresse à un système
                automatisé et non à une personne. Il peut demander à être orienté vers un collaborateur. Les éventuelles
                réponses fournies par l'assistant virtuel sont générées de manière automatisée et peuvent comporter des
                inexactitudes. Ces réponses ne constituent dès lors ni un conseil ni une recommandation et l'utilisateur
                demeure seul responsable de l'usage qu'il en fait. Le recours à l'assistant virtuel n'est pas
                obligatoire pour accéder aux services d'AMP IT.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                À la demande de l'utilisateur, l'assistant virtuel peut également exécuter certaines opérations sur son
                compte, telles que la gestion des programmations de recharge ou l'envoi de commandes à une borne. Ces
                opérations sont présentées à l'utilisateur et ne sont exécutées qu'après sa confirmation explicite, dans
                les limites de ses droits d'accès. L'utilisateur demeure seul responsable des opérations qu'il confirme,
                au même titre que s'il les avait effectuées lui-même dans l'application.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                14. Exclusion de responsabilité générale
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT ne peut en aucun cas être tenue pour responsable à l'égard d'un utilisateur ou d'un tiers de tout
                dommage, y compris indirect ou consécutif comprenant notamment la perte de manque à gagner, d'économie,
                de production, de contrat ou d'opportunités commerciales en lien avec l'utilisation des applications et
                dans le cadre de ses services, sous réserve d'une négligence grave ou d'un comportement dolosif à
                l'égard d'un utilisateur.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT met à disposition de ses clients, dans le cadre de ses prestations, des outils de communication,
                de chat, d'assistance automatisée et d'intelligence artificielle (IA), notamment afin de faciliter
                l'utilisation de ses services, répondre aux demandes des utilisateurs, fournir une assistance ou
                améliorer ses prestations. Les réponses ou informations générées au moyen de tels outils peuvent être
                produites automatiquement et ne constituent pas nécessairement des conseils ou recommandations d'AMP IT.
                L'utilisateur reconnaît que les résultats générés par des outils d'IA peuvent contenir des erreurs ou
                des inexactitudes et ne doivent pas être utilisés sans vérification lorsqu'une décision ou une action
                importante en dépend. L'utilisateur libère AMP IT de toute responsabilité en lien avec le recours à
                l'assistance automatisée ou à l'intelligence artificielle, sous réserve d'une négligence grave ou d'un
                comportement dolosif à l'égard d'un utilisateur.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                15. Protection des données
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Lors de l'utilisation du site internet, des applications et lors de contacts avec AMP IT, il se peut que
                des données soient collectées.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT s'engage à traiter les données de ses utilisateurs conformément à la législation en vigueur.
                Chaque utilisateur est néanmoins informé que certaines données collectées par AMP IT (i) servent à
                l'administration de son compte personnel, (ii) puissent être transférées à des tiers dans la mesure où
                cela est indispensable pour la réalisation des services et l'utilisation des applications, (iii) servent
                à envoyer de la publicité et des offres ciblées, dans les limites prévues par la politique de
                confidentialité et sous réserve du consentement lorsque celui-ci est requis, ou (iv) servent dans un but
                de recouvrement de créances.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Dans le cadre de ces services, AMP IT peut recourir à des outils de communication, de chat, d'assistance
                automatisée et d'intelligence artificielle (IA), notamment afin de faciliter l'utilisation de ses
                services, répondre aux demandes des utilisateurs, fournir une assistance ou améliorer ses prestations.
                Elle peut traiter les informations communiquées par l'utilisateur dans la mesure nécessaire à la
                fourniture et à l'amélioration de ses prestations. AMP IT peut traiter des données personnelles.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                L'utilisateur s'engage à ne communiquer, par l'intermédiaire du chat ou de tout outil d'IA mis à
                disposition par AMP IT, que les données nécessaires à l'utilisation du service et à ses besoins. Il
                s'engage à ne pas saisir de données personnelles sensibles, données confidentielles ou informations dont
                la communication à un tel outil serait interdite ou nécessiterait des mesures particulières, sauf
                indication contraire expresse d'AMP IT.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Dans la mesure où des outils d'IA ou des prestataires tiers sont utilisés pour fournir les services,
                certaines données peuvent être traitées par ces prestataires, y compris, le cas échéant, à l'étranger,
                sous réserve du périmètre de traitement limité à la Suisse et à l'Union européenne garanti au chiffre
                2.2.3.3 de la politique de confidentialité pour l'assistant virtuel. AMP IT veille à ce que tout
                traitement de données personnelles soit effectué conformément aux exigences légales applicables.
                L'utilisateur peut, en tout temps, prendre connaissance de la politique de confidentialité d'AMP IT.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                16. Modification des Conditions générales
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                AMP IT peut à tout moment modifier les présentes Conditions Générales d’utilisation du site web. Ces
                modifications relèvent de l'entière discrétion d'AMP IT. La version en vigueur est celle publiée sur
                notre site internet et dans nos applications; elle porte la date figurant en tête du présent document.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                17. Propriété intellectuelle
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Tous les droits de propriété intellectuelle relatifs aux services ainsi qu'à la documentation relative
                aux prestations de services demeurent la propriété exclusive d'AMP IT. Toute reproduction est interdite
                et peut donner lieu à des poursuites judiciaires.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                18. Droit applicable
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Tout contrat conclu et relations avec AMP IT ainsi que les présentes Conditions générales sont régis par
                le droit matériel suisse uniquement.
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                Sous réserve d'éventuels fors impératifs, tous litiges, différends ou prétentions nés d'un contrat,
                d'une relation avec AMP IT ou des présentes Conditions générales ou se rapportant à celles-ci, seront
                tranchés par les tribunaux compétents au siège d'AMP IT.
            </Typography>

            <Typography
                variant="h6"
                sx={termsOfUseSx.paragraph}
            >
                Mentions légales
            </Typography>
            <Typography
                variant="body2"
                sx={termsOfUseSx.paragraph}
            >
                • AMP IT SA<br/>
                • Adresse : 1-3 Rue des Sablières, 1242 Satigny, Suisse<br/>
                • Téléphone : +41 22 525 77 22<br/>
                • E-mail : <a href="mailto:info@amp-it.ch">info@amp-it.ch</a><br/>
                • IDE : CHE-398.067.199
            </Typography>
        </Box>
    );
};